<form *ngIf="inputFormGroup" [formGroup]="inputFormGroup" class="engineer-joint-form-main">
    <app-joint-configuration [form]="inputFormGroup"></app-joint-configuration>

    <app-bolt-type [form]="inputFormGroup" (selected)="onSelectedBoltType($event)"></app-bolt-type>

    <app-thread-type-bolt-size [form]="inputFormGroup" [boltType]="boltType" (selected)="onSelectedBoltSize($event)"></app-thread-type-bolt-size>

    <app-bolt-quantity [form]="inputFormGroup"></app-bolt-quantity>

    <app-reduced-area-bolting [form]="inputFormGroup"></app-reduced-area-bolting>

    <app-nut-standard [form]="inputFormGroup" [boltDimensionId]="boltDimensionId"></app-nut-standard>

    <app-joint-thickness [form]="inputFormGroup"></app-joint-thickness>

    <app-bolt-hole-diameter [form]="inputFormGroup"></app-bolt-hole-diameter>

    <app-gasket-comp-thickness [form]="inputFormGroup"></app-gasket-comp-thickness>

    <app-tightening-specification [form]="inputFormGroup" [isEngineeredJoint]="true" [calculationType]="calculationType"></app-tightening-specification>

    <app-bolt-material
        class="input-wrapper-list"
        [form]="inputFormGroup"
        [isGetAllBoltMaterials]="true"
        [doBoltMaterialReset]="boltMaterialReset"
        (selected)="onSelectedBoltMaterial($event)"
    ></app-bolt-material>

    <app-flange-material
        class="input-wrapper-list"
        [form]="inputFormGroup"
        [isEngineeredJoint]="true"
        [controlId]="'flangeMaterial1'"
        [controlLabel]="'Joint Material 1'"
        [doFlangeMaterialReset]="flangeMaterial1Reset"
        (selected)="onSelectedFlangeMaterial('flangeMaterial1', $event)"
    ></app-flange-material>

    <app-flange-material
        class="input-wrapper-list"
        [form]="inputFormGroup"
        [isEngineeredJoint]="true"
        [controlId]="'flangeMaterial2'"
        [controlLabel]="'Joint Material 2'"
        [doFlangeMaterialReset]="flangeMaterial2Reset"
        (selected)="onSelectedFlangeMaterial('flangeMaterial2', $event)"
    ></app-flange-material>

    <app-gasket class="input-wrapper-list" [form]="inputFormGroup" [isEngineeredJoint]="true" [doGasketReset]="gasketReset"></app-gasket>

    <div *ngIf="tighteningMethod == 1">
        <app-padditional [form]="inputFormGroup"></app-padditional>
    </div>

    <div class="" *ngIf="idmsSharedService.enableConfirmWithRouter(1)">
        <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth" (click)="btnEngJointConfirmClicked()">
            <!-- Confirm -->
            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
        </a>
    </div>
</form>
